import { $$ } from 'utils/dom';
import LoadMore from 'modules/load-more';

const eventTeasers = $$('.event-teaser[data-ajax]');
eventTeasers.length &&
  eventTeasers.forEach(teaser => {
    teaser &&
      new LoadMore({
        container: teaser,
      }).init();
  });
